<new-network-dialog [(display)]="displayNewNetworkDialog" (onClose)="onNewNetworkDialogClose()">
</new-network-dialog>

@if (!isObserver) {
<div style="margin-bottom: 30px;">
  <div class="header-row">
    <span style="font-size: 20px; font-weight: bold;">
      My Networks
    </span>
  </div>
  @if (hasNetworks) {
  <div>
    <!-- Search Box-->
    <div style="margin-top: 10px; margin-bottom: 10px;">
      <i class="fa fa-filter search-icon"></i>
      <input type="text" pInputText size="50" placeholder="Filter Networks..."
        (input)="tt.filterGlobal($event.target.value, 'contains')" style="width:auto">
      <!-- Add network button -->
      <button type="button" (click)="displayNewNetworkDialog = true" [disabled]="!isLicenseValid" pButton
        icon="fa fa-plus-square-o" label="Add Network" class="add-button">
      </button>
    </div>
    <!-- Data table -->
    <p-table #tt [value]="networks" [globalFilterFields]="['Name','Description']" rowHover="true" [scrollable]="true"
      [resizableColumns]="true"> <!--[scrollHeight]="myNetworksTableScrollHeight"-->
      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn>Name</th>
          <th pResizableColumn>Description</th>
          <th pResizableColumn>Owner</th>
          <th pResizableColumn>Created</th>
          <th pResizableColumn>Modified</th>
          <th pResizableColumn [ngClass]="{'uv-table-button-column-3': isAdmin, 'uv-table-button-column-2': !isAdmin}">
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr class="uv-table-row" (click)="onNetworkClick(rowData.Guid)">
          <td>
            <span class="uv-table-value">{{ rowData.Name }}</span>
          </td>
          <td>
            <span class="uv-table-value">{{ rowData.Description }}</span>
          </td>
          <td>
            <span class="uv-table-value">{{ rowData.Owner }}</span>
          </td>
          <td>
            <span class="uv-table-value">{{ formatDateHm(rowData.Created) }}</span>
          </td>
          <td>
            <span class="uv-table-value">{{ formatDateHm(rowData.Modified) }}</span>
          </td>
          <td [ngClass]="{'uv-table-button-column-3': isAdmin, 'uv-table-button-column-2': !isAdmin}">
            <button class="btn btn-primary uv-first-table-button" title="Share this network"
              [disabled]="!isLicenseValid" (click)="onSharingClick($event, rowData)">
              <i class="fa fa-share-alt"></i>
            </button>
            @if (isAdmin) {
            <button class="btn btn-primary uv-table-button" title="Change this network's owner"
              [disabled]="!isLicenseValid" (click)="onTransferClick($event, rowData)">
              <i class="fa fa-exchange"></i>
            </button>
            }
            <button class="btn btn-danger uv-table-button" title="Delete this network" [disabled]="!isLicenseValid"
              (click)="tryDeleteNetView($event, rowData.Guid)">
              <i class="pi pi-trash"></i>
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <confirmation-dialog message="Are you sure you want to delete this network?" [display]="displayDeleteNetViewConfirm"
      (onYes)="deleteNetView()" (onNo)="cancelDeleteNetView()">
    </confirmation-dialog>
    <share-source-dialog [(display)]="displaySharingDialog" [sharedItemGuid]="sharedItemGuid"
      [sourceUserGuid]="sourceUserGuid"></share-source-dialog>
    <user-selector header="Select new network owner" [(visible)]="displayUserSelectorDialog" [minUsers]="1"
      [maxUsers]="1" [except]="xferUserSelectorExceptions" format="full" (onOk)="initiateNetworkTransfer($event)"
      (onCancel)="cancelNetworkTransfer()"></user-selector>
    <prepare-network-transfer-dialog [(visible)]="displayPrepareTransferDialog" [transferScope]="xferScope"
      [transferTargetUser]="xferTargetUser" [transferInfo]="xferInfo" (onOk)="doNetworkTransfer($event)"
      (onCancel)="cancelNetworkTransfer()"></prepare-network-transfer-dialog>
  </div>
  }
  @if (!hasNetworks) {
  <div>
    @if (!hasNetworks) {
    <span style="font-size: 18px; font-weight: 500;">Click the &apos;Add Network&apos; button to create a
      network.</span>
    }
    <!-- Add network button -->
    <button type="button" (click)="displayNewNetworkDialog = true" [disabled]="!isLicenseValid" pButton
      icon="fa fa-plus-square-o" label="Add Network" class="add-button">
    </button>
  </div>
  }
</div>
}

@if (!isAdmin) {
<div>
  <legend style="font-size: 20px; font-weight: bold;">
    Networks Shared With Me
  </legend>
  @if (hasShares) {
  <div>
    <!-- Search Box-->
    <div style="margin-top: 20px; margin-bottom: 10px;">
      <i class="fa fa-filter search-icon"></i>
      <input type="text" pInputText size="50" placeholder="Filter Networks..."
        (input)="sharedtable.filterGlobal($event.target.value, 'contains')" style="width:auto">
    </div>
    <!-- Data table -->
    <p-table #sharedtable [value]="shares"
      [globalFilterFields]="['name','description','owner','targetName','targetType','access']" [scrollable]="true"
      [scrollHeight]="sharedNetworksTableScrollHeight" rowHover="true" [resizableColumns]="true">
      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn>Name</th>
          <th pResizableColumn>Description</th>
          <th pResizableColumn>Owner</th>
          <th pResizableColumn>Shared With</th>
          <th pResizableColumn>Type</th>
          <th pResizableColumn>Access</th>
          <th class="uv-table-button-column-1"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr (click)="onNetworkClick(rowData.networkGuid)">
          <td>
            <span class="uv-table-value">{{ rowData.name }}</span>
          </td>
          <td>
            <span class="uv-table-value">{{ rowData.description }}</span>
          </td>
          <td>
            <span class="uv-table-value">{{ rowData.owner }}</span>
          </td>
          <td>
            <span class="uv-table-value">{{ rowData.targetName }}</span>
          </td>
          <td>
            <span class="uv-table-value">{{ rowData.targetType }}</span>
          </td>
          <td>
            <span class="uv-table-value">{{ rowData.access }}</span>
          </td>
          <td class="uv-table-button-column-1">
            <button type="button" class="btn btn-danger uv-first-table-button" title="Unshare this network"
              [disabled]="rowData.targetType == 'Group'" (click)="tryDeleteShare($event, rowData.shareGuid)">
              <i class="pi pi-trash"></i>
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <confirmation-dialog message="Are you sure you want to unshare this network?" [display]="displayDeleteShareConfirm"
      (onYes)="deleteShare()" (onNo)="cancelDeleteShare()">
    </confirmation-dialog>
  </div>
  }
  @if (!hasShares) {
  <span style="font-size: 18px; font-weight: 500;">No networks have been shared with you.</span>
  }
</div>
}

<!-- <button class="btn btn-primary" (click)="detailsOffCanvas.open()">Test</button>
<uvx-offcanvas #detailsOffCanvas title="Testing the new component"></uvx-offcanvas> -->